import React, { FC } from 'react'
import styles from './TrophyMemoryCardSkeleton.module.scss'

export const TrophyMemoryCardSkeleton: FC = () => {
  return (
    <section className={ styles.trophyMemoryCardSkeleton__container } />
  )
}
